import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, NotebookPen, Printer } from "lucide-react";
import { api } from "@/lib/api";
import { Empty, Loader } from "@/components/cast/Common";
import { PlusGate } from "@/components/cast/PlusGate";
import { MARKS } from "@/lib/deep";

export default function DeepNotes() {
  const [data, setData] = useState<any>(null);
  const [locked, setLocked] = useState(false);
  useEffect(() => { api.get("/deep/notes").then((r) => setData(r.data)).catch((e) => e?.response?.status === 403 && setLocked(true)); }, []);
  if (locked) return <PlusGate testId="notes-gate" title="My Notes is part of Cast Plus" body="Write notes on the verses you highlight in Deep Dive and keep them all in one journal." />;
  if (!data) return <Loader />;
  return (
    <div data-testid="deep-notes-page" className="mx-auto max-w-3xl">
      <div className="flex flex-wrap items-center justify-between gap-3 print:hidden">
        <Link to="/deep-dive" data-testid="notes-back" className="flex items-center gap-1 text-sm font-semibold text-slate-600 hover:text-slate-900"><ChevronLeft className="h-4 w-4" />Deep Dive</Link>
        {data.count > 0 && <button data-testid="notes-print" onClick={() => window.print()} className="flex items-center gap-2 rounded-full bg-[#1E293B] px-5 py-2.5 text-sm font-semibold text-white"><Printer className="h-4 w-4" />Print my notes</button>}
      </div>
      <p className="eyebrow mt-8">Deep Dive journal</p>
      <h1 className="mt-2 font-display text-5xl font-semibold text-slate-900 sm:text-6xl">My Notes</h1>
      <p className="mt-2 text-slate-600" data-testid="notes-count">{data.count} {data.count === 1 ? "note" : "notes"} across {data.books.length} {data.books.length === 1 ? "book" : "books"} · {data.abbr}</p>
      {data.count === 0 ? <div className="mt-10"><Empty testId="notes-empty" title="No notes yet" body="Highlight a verse in Deep Dive, then tap the pen to write what it means to you." /></div> : (
        <div className="mt-10 space-y-12">
          {data.books.map((b: any) => (
            <section key={b.book} data-testid={`notes-book-${b.book}`} className="break-inside-avoid-page">
              <h2 className="flex items-center gap-3 border-b border-[#E2DBCE] pb-2 font-display text-3xl font-semibold text-slate-900"><NotebookPen className="h-5 w-5 text-[#C86D51] print:hidden" />{b.name}</h2>
              <div className="mt-5 space-y-6">
                {b.notes.map((n: any) => (
                  <article key={n.ref} className="break-inside-avoid border-l-4 pl-5" style={{ borderColor: MARKS[n.color]?.dot }} data-testid={`notes-item-${b.book}-${n.ch}-${n.verse}`}>
                    <Link to={`/deep-dive/${b.book}/${n.ch}`} className="text-sm font-semibold text-[#C86D51] hover:underline print:text-slate-700">{n.ref}</Link>
                    <p className="mt-1 font-scripture text-lg italic text-slate-700">“{n.text}”</p>
                    <p className="mt-2 whitespace-pre-line text-slate-900">{n.note}</p>
                  </article>
                ))}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
